import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';

;

export const CustomTooltip = withStyles(theme => ({
  tooltip: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    color: '#222',
    backgroundColor: '#fff',
    maxWidth: 220,
    padding: theme.spacing(2),
    fontSize: theme.typography.pxToRem(12),
    boxShadow: '0 3px 20px 1px rgb(0, 0, 0, 0.3)',
  },
  arrow: {
    color: '#fff',
  },
}))(Tooltip);
